import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.2.0_next@15.2.8_@opentelemetry+api@1.9.0_@playwright+test@1.50.1_rea_cyg2t5kkltqeask7ejmemfpnse/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/cropperjs@1.6.2/node_modules/cropperjs/dist/cropper.css");
